import { History } from 'history';
import { Dispatch, Middleware } from 'redux';
const nextTick = require('next-tick');

import { ROUTER_PUSH_ACTION } from '../redux/actions/actions-consts';
import { AppState } from '../redux/reducers';
import isAction from './helpers';



const routerMiddleware = (history: History): Middleware => (store) => (
  next: Dispatch<AppState>
) => (action: any): void => {
  if (isAction(action)) {
    if (action.type === ROUTER_PUSH_ACTION) {
      history.push(action.payload);
    }
    next(action);
    return;
  }

  nextTick(() => next(action));
};

export default routerMiddleware;
